import { defineMessages, IntlShape } from "react-intl";

import FollowUpTime from "@mapmycustomers/shared/enum/activity/FollowUpTime";

const messages = defineMessages<FollowUpTime>({
  [FollowUpTime.CUSTOM]: {
    id: "followUpTime.custom",
    defaultMessage: "Custom",
    description: "Custom follow up time",
  },
  [FollowUpTime.ONE_DAY]: {
    id: "followUpTime.oneDay",
    defaultMessage: "1 business day",
    description: "1 day follow up time",
  },
  [FollowUpTime.ONE_MONTH]: {
    id: "followUpTime.oneMonth",
    defaultMessage: "1 month",
    description: "1 month follow up time",
  },
  [FollowUpTime.ONE_WEEK]: {
    id: "followUpTime.oneWeek",
    defaultMessage: "1 week",
    description: "1 week follow up time",
  },
  [FollowUpTime.THREE_MONTHS]: {
    id: "followUpTime.threeMonths",
    defaultMessage: "3 months",
    description: "3 months follow up time",
  },
  [FollowUpTime.TWO_DAYS]: {
    id: "followUpTime.twoDays",
    defaultMessage: "2 business days",
    description: "2 days follow up time",
  },
  [FollowUpTime.TWO_WEEKS]: {
    id: "followUpTime.twoWeeks",
    defaultMessage: "2 weeks",
    description: "2 weeks follow up time",
  },
});

export const getFollowUpTimeDisplayName = (intl: IntlShape, time: FollowUpTime) =>
  intl.formatMessage(messages[time]);
